// Card 119 — resolving a module's symbolic CTA target to a route.
//
// The API never ships URLs in content: the same module set is rendered by this
// dashboard and by the Expo app, which has no concept of a path. Content says
// `payout_onboarding`, each client decides where that is.
//
// Anything unrecognised resolves to null and the CTA is simply not rendered, so
// a module authored against a target this build does not know about degrades to
// a readable article rather than a dead button.
const TARGET_ROUTES = {
  payout_onboarding: '/payoutlink',
  balance: '/tipdirect/balance',
  get_tips: '/tipdirect/tipdirect',
  reviews: '/tipdirect/reviews',
  select_tours: '/tipdirect/profile',
  profile: '/tipdirect/profile',
  dashboard: '/tipdirect/dashboard'
};

export const resolveCtaTarget = target => TARGET_ROUTES[target] || null;

export const learnModulePath = moduleId => `/tipdirect/learn?module=${encodeURIComponent(moduleId)}`;
